const timelineData = [
  {
    year: "1988",
    side: "right",
    faIcon: "fa-solid fa-hard-hat",
    title: "Career Foundation",
    description: "Founder began career in a leading electrical contact manufacturing company.",
  },
  {
    year: "1990",
    side: "left",
    faIcon: "fa-solid fa-industry",
    title: "First Manufacturing",
    description: "Started manufacturing of copper & bimetal contact rivets.",
  },
  {
    year: "1990 – 2014",
    side: "right",
    faIcon: "fa-solid fa-gears",
    title: "Operations Leadership",
    description:
      "Led manufacturing operations single-handedly with full responsibility of production management and technical supervision.",
  },
  {
    year: "2014",
    side: "left",
    faIcon: "fa-solid fa-building-flag",
    title: "G.A.D Electrical Founded",
    boldPrefix: "Established G.A.D",
    description:
      " Electrical Industries with vision of precision and quality-driven manufacturing.",
  },
  {
    year: "2022",
    side: "right",
    faIcon: "fa-solid fa-plug-circle-bolt",
    title: "OEM Expansion",
    description:
      "Expanded OEM supply to modular switch & MCB manufacturers across India.",
  },
  {
    year: "2025",
    side: "left",
    faIcon: "fa-solid fa-earth-asia",
    title: "Pan-India Presence",
    boldPrefix: "Strengthened pan-India industrial",
    description:
      " presence with long-term OEM partnerships and batch traceability system.",
  },
];

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=Source+Sans+3:wght@300;400;600;700&display=swap');

  :root {
    --navy: #0f2044;
    --navy-light: #162c5e;
    --navy-mid: #1a3a6e;
    --orange: #ff6b35;
    --orange-dark: #d9521e;
    --white: #ffffff;
    --white-70: rgba(255,255,255,0.70);
    --white-50: rgba(255,255,255,0.50);
  }

  * { margin: 0; padding: 0; box-sizing: border-box; }

  body {
    background: var(--navy);
    font-family: 'Source Sans 3', sans-serif;
    -webkit-font-smoothing: antialiased;
  }

  .lp-page {
    min-height: 100vh;
    width: 100%;
    background:
      radial-gradient(ellipse 120% 55% at 50% -5%, #1e4080 0%, transparent 65%),
      radial-gradient(ellipse 80% 40% at 20% 60%, #0d1e3d 0%, transparent 60%),
      radial-gradient(ellipse 70% 35% at 80% 80%, rgba(255,107,53,0.06) 0%, transparent 65%),
      linear-gradient(175deg, #0f2044 0%, #596a8d 50%, #FCF2F1 100%);
    color: var(--white);
  }

  .lp-inner {
    max-width: 1000px;
    margin: 0 auto;
    padding: 80px 80px 100px;
    position: relative;
    z-index: 1;
  }

  /* ── HEADER ── */
  .lp-header {
    text-align: center;
    margin-bottom: 90px;
  }

  .lp-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    letter-spacing: 0.38em;
    font-size: 0.83rem;
    font-weight: 700;
    color: var(--orange);
    text-transform: uppercase;
    margin-bottom: 22px;
  }
  .lp-eyebrow::before,
  .lp-eyebrow::after {
    content: '';
    display: block;
    width: 50px;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--orange));
  }
  .lp-eyebrow::after { background: linear-gradient(90deg, var(--orange), transparent); }

  .lp-h1 {
    font-family: 'Playfair Display', serif;
    font-size: clamp(1rem, 2vw, 3.2rem);
    font-weight: 700;
    line-height: 1.15;
    color: var(--white);
    margin-bottom: 14px;
    letter-spacing: -0.01em;
  }
  .lp-h1 .glow-text {
    color: var(--orange);
    text-shadow: 0 0 20px rgba(255,107,53,0.85), 0 0 60px rgba(255,107,53,0.45), 0 0 110px rgba(255,107,53,0.18);
  }

  .lp-subtitle {
    font-size: 1.12rem;
    color: var(--white-70);
    max-width: 660px;
    margin: 0 auto;
    line-height: 1.85;
    font-weight: 300;
  }

  /* ── TIMELINE OUTER ── */
  .tl-wrap {
    position: relative;
    margin: 0 auto 100px;
    padding: 10px 0;
  }

  /* Spine */
  .tl-spine {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0; bottom: 0;
    width: 4px;
    border-radius: 4px;
    background: linear-gradient(to bottom, transparent 0%, var(--orange) 5%, var(--orange) 95%, transparent 100%);
    box-shadow:
      0 0 10px 3px rgba(255,107,53,0.75),
      0 0 30px 8px rgba(255,107,53,0.38),
      0 0 80px 18px rgba(255,107,53,0.12);
    z-index: 0;
    pointer-events: none;
  }
  .tl-spine::after {
    content: '';
    position: absolute;
    left: 50%; transform: translateX(-50%);
    width: 14px; height: 90px;
    border-radius: 50%;
    background: radial-gradient(ellipse, rgba(255,210,160,0.95) 0%, rgba(255,107,53,0.65) 40%, transparent 80%);
    animation: travelGlow 4s ease-in-out infinite;
    top: 0;
  }
  @keyframes travelGlow {
    0%   { top: 0%;  opacity: 0; }
    8%   { opacity: 1; }
    92%  { opacity: 1; }
    100% { top: 94%; opacity: 0; }
  }

  /* ── EACH ROW ──
     Strategy: each row is a flex container.
     The node is ALWAYS centred at exactly 50% of the row via: margin-left/right auto trick.
     Card and node are direct siblings with no gap.

     RIGHT items:  [card][node][spacer]   — card is on the LEFT of node
     LEFT  items:  [spacer][node][card]   — card is on the RIGHT of node

     We achieve this with a 3-slot flex row where:
       slot A = flex:1  (card for RIGHT, spacer for LEFT)
       slot B = fixed node width (110px)
       slot C = flex:1  (spacer for RIGHT, card for LEFT)

     The card itself fills its slot completely → it always touches the node.
  */
  .tl-item {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    position: relative;
    z-index: 1;
    opacity: 0;
    transform: translateY(28px);
    animation: fadeUp 0.7s ease forwards;
  }
  .tl-item:nth-child(2) { animation-delay: 0.08s; }
  .tl-item:nth-child(3) { animation-delay: 0.18s; }
  .tl-item:nth-child(4) { animation-delay: 0.28s; }
  .tl-item:nth-child(5) { animation-delay: 0.38s; }
  .tl-item:nth-child(6) { animation-delay: 0.48s; }
  .tl-item:nth-child(7) { animation-delay: 0.58s; }
  @keyframes fadeUp { to { opacity: 1; transform: translateY(0); } }

  /* Slot A — left half */
  .tl-slot-left {
    flex: 1;
    display: flex;
    justify-content: flex-end; /* content hugs the center */
    align-items: center;
    min-width: 0;
  }

  /* Slot C — right half */
  .tl-slot-right {
    flex: 1;
    display: flex;
    justify-content: flex-start; /* content hugs the center */
    align-items: center;
    min-width: 0;
  }

  /* Node slot — fixed, always center */
  .tl-node {
    width: 110px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
  }

  /* ── CARD ── */
  .tl-card {
    background: linear-gradient(140deg, rgba(30,62,116,0.55) 0%, rgba(15,32,68,0.72) 100%);
    border: 1px solid rgba(255,107,53,0.2);
    border-radius: 18px;
    padding: 30px 36px;
    position: relative;
    backdrop-filter: blur(10px);
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
    cursor: default;
    width: 100%;
    max-width: 380px;
  }
  .tl-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 16px 48px rgba(255,107,53,0.22), 0 4px 20px rgba(0,0,0,0.45);
    border-color: rgba(255,107,53,0.52);
  }

  /* Arrow for RIGHT items: card is in left slot, arrow points RIGHT toward node */
  .tl-item.right .tl-card {
    text-align: right;
  }
  .tl-item.right .tl-card::after {
    content: '';
    position: absolute;
    right: -11px; top: 50%;
    transform: translateY(-50%);
    border: 11px solid transparent;
    border-left-color: rgba(255,107,53,0.35);
  }

  /* Arrow for LEFT items: card is in right slot, arrow points LEFT toward node */
  .tl-item.left .tl-card {
    text-align: left;
  }
  .tl-item.left .tl-card::after {
    content: '';
    position: absolute;
    left: -11px; top: 50%;
    transform: translateY(-50%);
    border: 11px solid transparent;
    border-right-color: rgba(255,107,53,0.35);
  }

  .tl-year {
    display: inline-block;
    background: linear-gradient(135deg, var(--orange) 0%, var(--orange-dark) 100%);
    color: #fff;
    font-weight: 700;
    font-size: 0.9rem;
    padding: 5px 18px;
    border-radius: 30px;
    margin-bottom: 11px;
    letter-spacing: 0.04em;
    box-shadow:
      0 0 14px rgba(255,107,53,0.75),
      0 0 42px rgba(255,107,53,0.28),
      inset 0 1px 0 rgba(255,255,255,0.22);
  }

  .tl-card-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.18rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 9px;
  }

  .tl-card-desc {
    font-size: 0.94rem;
    color: var(--white-70);
    line-height: 1.72;
    font-weight: 300;
  }
  .tl-card-desc strong {
    color: var(--white);
    font-weight: 600;

  }

  /* ── NODE CIRCLE ── */
  .node-ring {
    width: 110px; height: 110px;
    border-radius: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .node-ring::before {
    content: '';
    position: absolute;
    inset: -7px;
    border-radius: 50%;
    border: 2.5px solid var(--orange);
    box-shadow:
      0 0 22px 6px rgba(255,107,53,0.8),
      0 0 60px 14px rgba(255,107,53,0.38),
      0 0 110px 24px rgba(255,107,53,0.12),
      inset 0 0 24px rgba(255,107,53,0.18);
    animation: ringPulse 2.8s ease-in-out infinite;
  }
  .node-ring::after {
    content: '';
    position: absolute;
    inset: 5px;
    border-radius: 50%;
    border: 1px solid rgba(255,107,53,0.28);
    animation: ringPulse 2.8s ease-in-out infinite reverse;
  }
  @keyframes ringPulse {
    0%,100% { opacity: 1; transform: scale(1); }
    50%      { opacity: 0.65; transform: scale(1.06); }
  }

  .node-face {
    width: 90px; height: 90px;
    border-radius: 50%;
    background: radial-gradient(circle at 38% 30%, #243f72 0%, #172e5c 45%, #0f2044 100%);
    border: 1.5px solid rgba(255,107,53,0.38);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    box-shadow: inset 0 3px 14px rgba(0,0,0,0.65), inset 0 -2px 6px rgba(255,107,53,0.12);
    transition: transform 0.3s ease;
  }
  .node-ring:hover .node-face { transform: scale(1.06); }
  .node-face i {
    font-size: 2.5rem;
    color: var(--orange);
    filter:
      drop-shadow(0 0 8px rgba(255,107,53,0.95))
      drop-shadow(0 0 22px rgba(255,107,53,0.55))
      drop-shadow(0 0 40px rgba(255,107,53,0.25));
    transition: transform 0.3s ease;
  }
  .node-ring:hover .node-face i { transform: scale(1.12); }

  /* ── FOOTER ── */
  .lp-footer {
    text-align: center;
    padding-top: 65px;
    border-top: 1px solid rgba(255,107,53,0.18);
    position: relative;
  }
  .lp-footer::before {
    content: '';
    position: absolute;
    top: -2px; left: 50%;
    transform: translateX(-50%);
    width: 140px; height: 3px;
    background: var(--orange);
    box-shadow: 0 0 18px 5px rgba(255,107,53,0.75), 0 0 50px 10px rgba(255,107,53,0.3);
    border-radius: 3px;
  }
  .lp-footer-title {
    font-family: 'Playfair Display', serif;
    font-size: clamp(1.7rem, 3vw, 2.6rem);
    font-weight: 900;
    color: var(--white);
    margin-bottom: 20px;
    line-height: 1.3;
  }
  .lp-footer-title .glow-text {
    color: var(--orange);
    text-shadow: 0 0 18px rgba(255,107,53,0.85), 0 0 50px rgba(255,107,53,0.35);
  }
  .lp-footer-sub {
    font-size: 1rem;
    color: var(--white-70);
    max-width: 620px;
    margin: 0 auto;
    line-height: 1.82;
    font-weight: 300;

  }
  .lp-stats {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-top: 30px;
    flex-wrap: wrap;
    
  }
  .stat-item { text-align: center; }
  .stat-number {
    font-family: 'Playfair Display', serif;
    font-size: 2rem;
    font-weight: 700;
    color: var(--orange);
    text-shadow: 0 0 22px rgba(255,107,53,0.75), 0 0 55px rgba(255,107,53,0.32);
    line-height: 1;
  }
  .stat-label {
    font-size: 0.75rem;
    weight: 600;
    color: #0f2044;
    

    letter-spacing: 0.18em;
    text-transform: uppercase;
    margin-top: 8px;
    font-weight: 600;
  }

  /* ── RESPONSIVE ── */
  @media (max-width: 1000px) {
    .lp-inner { padding: 60px 40px 80px; }
    .tl-node { width: 90px; }
    .node-ring { width: 90px; height: 90px; }
    .node-face { width: 74px; height: 74px; }
    .node-face i { font-size: 2rem; }
    .tl-card { max-width: 300px; }
  }
  @media (max-width: 640px) {
    .lp-inner { padding: 44px 20px 60px; }
    .tl-item { margin-bottom: 24px; }
    .tl-node { width: 72px; }
    .node-ring { width: 68px; height: 68px; }
    .node-face { width: 56px; height: 56px; }
    .node-face i { font-size: 1.5rem; }
    .tl-card { padding: 14px 14px; border-radius: 12px; max-width: 200px; }
    .tl-card-title { font-size: 0.9rem; }
    .tl-card-desc { font-size: 0.78rem; }
    .tl-year { font-size: 0.78rem; padding: 4px 10px; }
    .lp-stats { gap: 30px; }
    .stat-number { font-size: 1.6rem; }
  }
`;

export default function LeadershipTimeline() {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
        crossOrigin="anonymous"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=Source+Sans+3:wght@300;400;600;700&display=swap"
        rel="stylesheet"
      />
      <style>{css}</style>

      <div className="lp-page">
        <div className="lp-inner">

          {/* HEADER */}
          <header className="lp-header">
            <p className="lp-eyebrow">Leadership Legacy</p>
            <h1 className="lp-h1">
              Built on 35+ Years of<br />
              Industry <span className="glow-text">Leadership</span>
            </h1>
            <p className="lp-subtitle">
              Our founder brings extensive hands-on expertise with a track record of
              technical excellence and leadership in the electrical contact manufacturing industry.
            </p>
          </header>

          {/* TIMELINE */}
          <div className="tl-wrap">
            <div className="tl-spine" />

            {timelineData.map((item, i) => (
              <div key={i} className={`tl-item ${item.side}`}>

                {/*
                  RIGHT:  slot-left=CARD  |  node  |  slot-right=EMPTY
                  LEFT:   slot-left=EMPTY |  node  |  slot-right=CARD
                  Card always fills its slot flush against node — zero gap.
                */}
                <div className="tl-slot-left">
                  {item.side === "right" && (
                    <div className="tl-card">
                      <span className="tl-year">{item.year}</span>
                      <h3 className="tl-card-title">{item.title}</h3>
                      <p className="tl-card-desc">
                        {item.boldPrefix
                          ? <><strong>{item.boldPrefix}</strong>{item.description}</>
                          : item.description}
                      </p>
                    </div>
                  )}
                </div>

                <div className="tl-node">
                  <div className="node-ring">
                    <div className="node-face">
                      <i className={item.faIcon}></i>
                    </div>
                  </div>
                </div>

                <div className="tl-slot-right">
                  {item.side === "left" && (
                    <div className="tl-card">
                      <span className="tl-year">{item.year}</span>
                      <h3 className="tl-card-title">{item.title}</h3>
                      <p className="tl-card-desc">
                        {item.boldPrefix
                          ? <><strong>{item.boldPrefix}</strong>{item.description}</>
                          : item.description}
                      </p>
                    </div>
                  )}
                </div>

              </div>
            ))}
          </div>

          {/* FOOTER */}
          <footer className="lp-footer">
           
            <div className="lp-stats">
              <div className="stat-item">
                <div className="stat-number">35+</div>
                <div className="stat-label">Years Experience</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">500+</div>
                <div className="stat-label">OEM Partners</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">Pan</div>
                <div className="stat-label">India Presence</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">Quality Driven</div>
              </div>
            </div>
          </footer>

        </div>
      </div>
    </>
  );
}